/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileArrowsUpRight: {
  name: 'file-arrows-up-right';
  data: string;
} = {
  name: 'file-arrows-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h4.586a1.5 1.5 0 0 1 1.06.44l3.415 3.414a1.5 1.5 0 0 1 .439 1.06V14a1.5 1.5 0 0 1-1.5 1.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 0 .5-.5V5.5H10A1.5 1.5 0 0 1 8.5 4V1.5H4a.5.5 0 0 0-.5.5v6a.5.5 0 0 1-1 0V2Zm7 .207V4a.5.5 0 0 0 .5.5h1.793L9.5 2.207ZM3 11.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-2.793l-3.146 3.147a.5.5 0 0 1-.708-.708L5.793 11.5H3Z" fill="currentColor"/></svg>`,
};
